export const API_BASE = `http://${process.env.REACT_APP_HOSTNAME || window.location.hostname}:3000`;
export const MARKETING_URL = `http://${process.env.REACT_APP_HOSTNAME || window.location.hostname}:3004/`;
export const STRIPE_API_KEY = 'pk_test_KlribgMO7zMceaBw25LU2NKE';
export const PRODUCTION_BUILD_TYPE = process.env.REACT_APP_PRODUCTION_BUILD_TYPE || 'pwa';